export const COMPARE_STATE_ACTION = {
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    ADD_PORT: 'ADD_PORT',
    REMOVE_PORT: 'REMOVE_PORT',
    SYNC_DATA: 'SYNC_DATA',
};
